import * as React from "react";
import { CheckboxGroup } from "../../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";

interface IDeclarationsProps extends IProcessComponentProps {}

interface IDeclarationsState {
    hasCheckedDeclarations: boolean;
}

export class Declarations extends ProcessComponent<IDeclarationsProps, IDeclarationsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            hasCheckedDeclarations: false,
        };
    }

    isValid() {
        if (!this.state.hasCheckedDeclarations) {
            this.props.showErrorMsgPopUp(["You must accept all items to continue"], true);
        }

        return super.isValid() && this.state.hasCheckedDeclarations;
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;

        return (
            <>
                <h2>Declarations</h2>
                <p className="checked-paragraph">I confirm that</p>
                <ol className="ml-15">
                    <li className="mb-15">
                        I have provided my client with all pre-sale information required under applicable laws and regulations, including (where applicable) the relevant
                        <ul>
                            <li className="mb-15">KFDs and KFIs;</li>
                            <li className="mb-15">KIDs, KIIDs and charges information documents (as applicable); and</li>
                            <li className="mb-15">SDR and investment label information documents (as applicable)</li>
                        </ul>
                        <div>
                            and that my client has had a reasonable opportunity to read these.
                        </div>
                    </li>
                    <li className="mb-15">
                        I will ensure that my client will meet the eligibility criteria of any investment held in their account as described in the relevant investment documentation.
                    </li>

                </ol>
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Confirm all",
                            disabled: this.props.isReview,
                            value: this.state.hasCheckedDeclarations,
                            onChange: (v) => {
                                this.setState({ hasCheckedDeclarations: v });
                            },
                        },
                    ]}
                />
            </>
        );
    }
}
